export class Statics {
    static defaultGraphicParts = "DS2000009"
}
